import Layout from '@layout/Index'

export const platform = [
  {
    path: '/platform',
    component: Layout,
    children: [
      {
        path: 'tag_table',
        component: () => import(/* webpackChunkName: "platform-tag-table" */ './pages/PlatformTagTable.vue'),
        name: '热搜标签管理',
        meta: {
          title: '热搜标签管理',
        },
      },
      {
        path: 'education_table',
        component: () => import(/* webpackChunkName: "platform-education-table" */ './pages/PlatformEducationTable.vue'),
        name: '教程管理',
        meta: {
          title: '教程管理',
        },
      },
      {
        path: 'education_form',
        component: () => import(/* webpackChunkName: "platform-education-form" */ './pages/PlatformEducationForm.vue'),
        name: '教程详情',
        meta: {
          title: '教程详情',
        },
      },
      {
        path: 'home-module-table',
        component: () => import(/* webpackChunkName: "platform-home-module-table" */ './pages/PlatformHomeModuleTable.vue'),
        name: 'APP首页模块配置',
        meta: {
          title: 'APP首页模块配置',
        },
      },
      {
        path: 'home-module-form',
        component: () => import(/* webpackChunkName: "platform-home-module-form" */ './pages/PlatformHomeModuleForm.vue'),
        name: '首页模块详情',
        meta: {
          title: '首页模块详情',
        },
      },
      {
        path: 'home-module-log-form',
        component: () => import(/* webpackChunkName: "platform-home-module-log-table" */ './pages/PlatformHomeModuleLogTable.vue'),
        name: '首页模块操作日志',
        meta: {
          title: '首页模块操作日志',
        },
      },
      {
        path: 'order-comment-table',
        component: () => import(/* webpackChunkName: "platform-home-module-log-table" */ './pages/PlatformOrderCommentTable.vue'),
        name: '评价管理',
        meta: {
          title: '评价管理',
        },
      },
      {
        path: 'sign-feedback-table',
        component: () => import(/* webpackChunkName: "platform-home-module-log-table" */ './pages/SignFeedBackTable.vue'),
        name: '签到反馈',
        meta: {
          title: '签到问题反馈',
        },
      },
      {
        path: 'sign-feedback-form',
        component: () => import(/* webpackChunkName: "platform-home-module-log-table" */ './pages/SignFeedBackForm.vue'),
        name: '更新门店',
        meta: {
          title: '更新门店',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/platform/platform.route.js